// Module
var code = `<div class="row"> <div class="col-12 text-center px-0 py-4"> <h1>Thanks for your submission.</h1> <h2>Someone will reach out shortly.</h2> </div> </div>`;
// Exports
export default code;